import React, { useContext, useEffect, useState } from 'react';
import JSONPretty from 'react-json-pretty';
import Grid from '@material-ui/core/Grid'
import LinearProgress from '@material-ui/core/LinearProgress';

import AuthContext from '../../../../services/firebase/AuthContext';
import FireDataContext from '../../../../services/firebase/FireDataContext';
import LoggingContext from '../../../../services/logging/LoggingContext';
import MemberMiniMenu from '../../../members/menus/MemberMiniMenu';
// import CaseInfoContent from './CaseInfoContent';
import ReferralSearchContent from './ReferralSearchContent';

const ReferralSearchPage = () => {
    const db = useContext(FireDataContext);
    const Errata = useContext(LoggingContext);
    const { currentUser } = useContext(AuthContext);

    const [referrals, setReferrals] = useState();
    const [courtCases, setCourtCases] = useState();
    const [digest, setDigest] = useState();

    useEffect(() => {
        db.referrals({ context: `ReferralSearchPage` })
            .then(data => {
                setReferrals(data.filter(({ courtCaseId }) => Boolean(courtCaseId)));
            })
            .catch(error => console.log(error));

        db.subcollection({ path: `cases`, context: `ReferralSearchPage` })
            .then(setCourtCases)
            .catch(error => console.log(error));
    }, [db]);

    const getReferralInfo = referral => {
        const { id: referralId = '', organizationId = '' } = referral || {};

        console.log('referral', referral);

        (async () => {
            try {

                const requests = await db.get({ path: `organizations/${organizationId}/referrals/${referralId}/intermediaries`, context: 'ReferralSearchPage' });

                console.log('requests', requests);

                // get the intermediary rfqs so we can find out the status
                const rfqs = await Promise.all(
                    requests.map(({ referralId, intermediaryId }) => {
                        return db.get({ path: `intermediaries/${intermediaryId}/referrals/${referralId}`, context: 'ReferralSearchPage' })
                    })
                );

                console.log('rfqs', rfqs);

                // get a unique list of intermediaries
                const intermediaryIds = [...new Set(requests.map(({ intermediaryId }) => intermediaryId))];

                console.log('intermediaryId', intermediaryIds)

                const users = await Promise.all(
                    intermediaryIds.map(id => {
                        return db.get({ path: `users/${id}`, context: 'ReferralSearchPage' })
                    })
                );

                console.log('users', users);

                setDigest({
                    referral,
                    requests,
                    rfqs,
                    users
                });

            }
            catch (error) {
                Errata.log({ component: 'ReferralSearchPage', user: currentUser, error });
            }
        })();
    }

    const handleSelect = courtCase => {
        getReferralInfo(courtCase);
    }

    return (
        <MemberMiniMenu>
            {
                !referrals && <LinearProgress />
            }
            {
                referrals && courtCases && 
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <ReferralSearchContent referrals={referrals} courtCases={courtCases} onSelect={handleSelect} />
                    </Grid>
                    <Grid item xs={8}>
                        {
                            digest && <JSONPretty data={digest} />
                        }
                    </Grid>
                </Grid>
            }
        </MemberMiniMenu>
    );
};

export default ReferralSearchPage;